<template>
  <div class="maincontent limit">
    <wwdheader></wwdheader>

    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="content" v-if="(hasSlot($slots.col1) || hasSlot($slots.col2))">
      <div class="content-col col-1">
        <slot name="col1"></slot>
      </div>

      <div class="content-col col-2">
        <slot name="col2"></slot>
        <div class="remark">
          <slot name="remark"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wwdheader from "@/components/wwdheader.vue";

export default {
  components: {
    wwdheader: wwdheader
  },
  methods: {
    hasSlot(slot) {
      return !!slot;
    }
  }
};
</script>

<style scoped lang="scss">
$max-width: 950px;
$page-padding: 40px;

.maincontent {
  // min-height: 800px;
  padding: $page-padding;

  background-color: $beige;
}

.header {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  text-align: center;
  line-height: 30px;

  @media screen and (max-width: $max-width) {
    align-items: flex-start;
  }

  h1 {
    margin-bottom: $page-padding;
    font-size: 2.5em;

    @media screen and (max-width: $max-width) {
      line-height: normal;
    }
  }

  margin-top: 150px;
  margin-bottom: 100px;

  @media screen and (max-width: $max-width) {
    text-align: left;
  }
}

.content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: left;

  @media screen and (max-width: $max-width) {
    grid-template-columns: 1fr;
  }

  .content-col {
    padding: 30px;

    &.col-1 {
      padding-left: 0;
      padding-right: $page-padding;
    }

    &.col-2 {
      padding-right: 0;
      padding-left: $page-padding;
    }

    @media screen and (max-width: $max-width) {
      &.col-1 {
        padding-left: unset;
        padding-right: unset;
      }

      &.col-2 {
        padding-right: unset;
        padding-left: unset;
      }
    }
  }

  p {
    line-height: 30px;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  ul {
    list-style-position: outside;
    padding-left: 20px;

    li {
      margin-bottom: 20px;
      margin-top: 20px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}

.remark {
  text-transform: uppercase;

  line-height: 40px;
  max-width: 80ch;
  margin-top: $page-padding;

  p {
    font-size: 28px;
  }
}

.subtitle {
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
}
</style>
